<template>
  <TGrid>
    <UCard
      v-for="(post, index) in posts"
      :key="index"
      as="a"
      :ui="carouselCardThreeWithoutBorder"
      :href="post.url"
      class="col-span-12 md:col-span-4 rounded-lg border mb-4 bg-white"
    >
      <TLazyimg
        :src="post.media.img2x"
        alt=""
        :classes-img="cardLazyImgRoundedTop"
        classes="aspect-w-4 aspect-h-2"
      />
      <template #footer>
        <div class="col-span-12 mt-3 mx-6">
          <TText color="primary600" variant="semibold">
            {{ post.category.name }}</TText
          >
          <TText tag="h3" variant="semibold">
            <span v-html="post.title"
          /></TText>
          <TText clamp="clamp9">{{ post.content }}</TText>
          <TText color="gray600">
            {{
              post.readingTime
                ? `${post.publishDate} - ${post.readingTime}`
                : post.publishDate
            }}</TText
          >
        </div>
      </template>
    </UCard>
    <UButton
      v-if="button && button.url"
      :ui="mobileFullWidthButton"
      size="md"
      variant="solid"
      :label="button.text"
      :to="button.url"
      external
      class="col-span-12 m-auto mt-8"
    />
  </TGrid>
</template>
<script setup lang="ts">
import { carouselCardThreeWithoutBorder } from '~~/modules/design-system/utils/nuxt-ui-config/components/card'
import { cardLazyImgRoundedTop } from '~~/modules/design-system/components/t-lazyimg/constants/config'
import { mobileFullWidthButton } from '~~/modules/design-system/utils/nuxt-ui-config/components/button'

export interface propsInterface {
  posts: Array<{
    title: string
    url: string
    media: {
      img: string
      img2x: string
    }
    category: {
      name: string
    }
    content: string
    readingTime?: string | null
    authorName: string
    authorUrl: string
    publishDate: string
  }>
  button?: {
    text: string
    url: string | null
  }
}

defineProps<propsInterface>()
</script>
